import { render } from "./blockLoading.vue?vue&type=template&id=62d2ac98"
import script from "./blockLoading.vue?vue&type=script&lang=js"
export * from "./blockLoading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__